import React from 'react';
import clsx from 'clsx';

/**
 * Reusable Button component with brand variants.
 */
const base = 'inline-flex items-center justify-center rounded-md font-medium tracking-wide focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-400 transition-all duration-200 ease-soft disabled:opacity-50 disabled:cursor-not-allowed';

const sizes = {
  sm: 'h-9 px-4 text-xs',
  md: 'h-11 px-6 text-sm',
  lg: 'h-12 px-8 text-sm',
};

const variants = {
  primary: 'bg-primary-600 hover:bg-primary-650 active:bg-primary-700 text-white shadow-sm hover:shadow focus-visible:ring-primary-300',
  outline: 'border border-neutral-300 text-neutral-700 hover:bg-neutral-50 active:bg-neutral-100',
  subtle: 'bg-primary-50 text-primary-700 hover:bg-primary-100',
  ghost: 'text-primary-600 hover:bg-primary-50 active:bg-primary-100'
};

export const Button = ({ as: Component = 'button', variant = 'primary', size = 'md', className, children, ...rest }) => {
  return (
    <Component className={clsx(base, sizes[size], variants[variant], className)} {...rest}>
      {children}
    </Component>
  );
};

export default Button;
